<template>
	<div class="news-detail">
        <div class="cube"></div>
        <div class="info">
            <div class="title">{{newsInfo.title}}</div>
            <div class="line"></div>
            <div class="date">{{newsInfo.news_date}}</div>
            <div class="bd ql-editor" v-html="newsInfo.body"></div>
        </div>
    </div>
</template>
<script>
    import { Component, Vue } from "vue-property-decorator";
    import { EventBus } from '@/utils/eventBus.js';
    import { getNewsDetail } from '@/api/news.js';

	@Component({})
	export default class Detail extends Vue {
        newsInfo = {};

        created() {
            EventBus.$emit('router.change', '/news');
            this.getNewsDetailData();
        }

        async getNewsDetailData() {
            const { code, data, message } = await getNewsDetail({ id: this.$route.params.id });

            if (code === 0) {
                this.newsInfo = data;
            } else {
                console.log(message);
            }
        }
    }
</script>
<style lang="scss">
    .news-detail {
        width: 1135px;
        padding: 197px 0 200px;
        position: relative;
        margin: 0 auto;
        .cube {
            width: 230px;
            height: 230px;
            background: url(https://appd.knowbox.cn/ss/activity/knowbox-web/img/news/cube-detail.png) no-repeat;
            background-size: 100% 100%;
            position: absolute;
            left: -135px;
        }
        .info {
            width: 868px;
            margin: 0 auto;
            padding-top: 61px;
            .title {
                font-weight: 700;
                font-size: 18px;
                font-family: PingFangSC-Medium;
            }
            .line {
                height: 1px;
                background: rgb(160, 162, 163); 
                float: right;
                width: 868px;
                margin: 20px 0;
            }
            .date {
                font-size: 16px;
                font-family: PingFangSC-light;
            }
            .bd {
                font-size: 14px;
                padding-top: 90px;
                line-height: 25px;
                font-family: PingFangSC-light;
                img {
                    width: 100%;
                }
            }
        }
    }
</style>
<style lang="css">
    @import './quill.core.css';
</style>



